export const CHANGE_SOURCE_LANG = 'translator/change_source_lang';
export const CHANGE_TARGET_LANG = 'translator/change_target_lang';
export const TOGGLE_IS_RECORDING = 'translator/toggle_is_recording';
export const CHANGE_SOURCE_TEXT = 'translator/change_source_text';
export const CHANGE_RESULT_TEXT = 'translator/change_result_text';